//@flow
import { REHYDRATE } from 'redux-persist';
import UISwitcherActions from 'common/redux/actions/uiSwitcher';
import { UISwitcherStateEnum as UI_SWICHER_STATES } from 'common/enums/UISwitcher';

const initialState = {
    v2PopupState: UI_SWICHER_STATES.NEW_UI
};

const uiSwitcherReducer = (
    state: Object = initialState,
    action: Object
): Object => {
    switch (action.type) {
        case REHYDRATE: {
            const savedData =
                action.payload && action.payload.uiSwitcher
                    ? action.payload.uiSwitcher
                    : initialState;
            return { ...state, ...savedData };
        }
        case UISwitcherActions.UPDATE_V2_POPUP_STATE: {
            const { payload } = action;
            return {
                ...state,
                v2PopupState: payload.popupState
            };
        }

        case UISwitcherActions.UPDATE_V2_LAST_NOTIFIED: {
            const { payload } = action;
            return {
                ...state,
                v2LastNotified: payload.timestamp
            };
        }

        case UISwitcherActions.READY_TO_SHOW_V2_POPUP: {
            const { payload } = action;
            return {
                ...state,
                isReadyToShowV2Popup: payload.show
            };
        }
        case UISwitcherActions.UPGRADE_LATER: {
            const { payload } = action;
            return {
                ...state,
                upgradeLater: payload.time
            };
        }
        case UISwitcherActions.ACKNOWLEDGE_V1_POPUP: {
            return {
                ...state,
                isV1PopupAcknowledged: true
            };
        }
        case UISwitcherActions.ACKNOWLEDGE_V2_POPUP: {
            return {
                ...state,
                isV2PopupAcknowledged: true
            };
        }
        case UISwitcherActions.ACKNOWLEDGE_ACCESS_WALKTHROUGH: {
            return {
                ...state,
                isAccessWalkthroughAcknowledged: true
            };
        }
        default: {
            return state;
        }
    }
};

const productWrapper = reducer => {
    return function (wrapperState = {}, action) {
        if (!action.payload || !action.payload.product) {
            return wrapperState;
        }

        const productState = wrapperState[action.payload.product];
        return {
            ...wrapperState,
            [action.payload.product]: reducer(productState, action)
        };
    };
};

export default productWrapper(uiSwitcherReducer);
